import { StyledFlex } from '@dreryk/react-components';

import { AvailabilityFormController } from '../../common.types';

import { AvailabilityTimeSlotFixed } from './AvailabilityTimeSlotFixed/AvailabilityTimeSlotFixed';
import {
   AvailabilityTimeSlotManual,
   slotDurationFixedFieldVisible,
} from './AvailabilityTimeSlotManual/AvailabilityTimeSlotManual';
import { AvailabilityTimeSlotValidatorField } from './AvailabilityTimeSlotValidatorField';

type AvailabilityTimeSlotSectionProps = {
   readonly register: AvailabilityFormController['register'];
   readonly formState: AvailabilityFormController['formState'];
   readonly watch: AvailabilityFormController['watch'];
   readonly trigger: AvailabilityFormController['trigger'];
};

export const AvailabilityTimeSlotSection = (props: AvailabilityTimeSlotSectionProps): JSX.Element => {
   return (
      <StyledFlex direction={'column'}>
         <StyledFlex gap={'20px'}>
            <AvailabilityTimeSlotFixed register={props.register} />
            <AvailabilityTimeSlotManual register={props.register} watch={props.watch} formState={props.formState} />
         </StyledFlex>
         {slotDurationFixedFieldVisible(props.watch) ? (
            <AvailabilityTimeSlotValidatorField register={props.register} watch={props.watch} trigger={props.trigger} />
         ) : null}
      </StyledFlex>
   );
};
